const BRANCH_VIEW_ELEMENT_ACTIONS = {
    DETACH_BRANCH: "DETACH_BRANCH",
    DELETE_BRANCH: "DELETE_BRANCH",
};

export default BRANCH_VIEW_ELEMENT_ACTIONS;
